<div class="navbar-area navbar-area-with-position-relative">
    <!-- <div class="container-fluid"
        style="background-image: radial-gradient(circle, #4829e6, #0050eb, #0068e7, #007bdd, #408bce); color: white !important;"> -->
    <div class="container-fluid px-0" *ngIf="!loadingData"
        style="background-image:url(assets/img/school/new-header.jpg); background-size: cover; background-position: center; color: white;">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-12 col-md-12">
                    <ul class="topbar-social-links d-flex align-items-center py-3 px-0" *ngIf="isBig">
                        <ng-container *ngIf="mainData != null">
                            <a class="navbar-brand d-flex align-items-center" routerLink="/">
                                <img [src]="mainData.LogoUrl || '/assets/img/school/logo.png'"
                                    onerror="this.src='/assets/img/school/logo.png';" alt="logo"
                                    class="brand-logo-img img-fluid">
                                <span class="ms-3 fw-bold glow-text brand-logo-text">{{mainData.Name || 'Proyash
                                    Chattogram'}}</span>
                            </a>
                        </ng-container>
                    </ul>
                    <ul class="topbar-social-links py-3 px-0" *ngIf="isSmall">
                        <ng-container *ngIf="mainData != null">
                            <a class="navbar-brand d-flex align-items-center" routerLink="/">
                                <img [src]="mainData.LogoUrl || '/assets/img/school/logo.png'"
                                    onerror="this.src='/assets/img/school/logo.png';" alt="logo"
                                    class="brand-logo-img img-fluid">
                                <span class="ms-3 fw-bold glow-text brand-logo-text">{{mainData.Name || 'Proyash
                                    Chattogram'}}</span>
                            </a>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid px-0 placeholder-glow" *ngIf="loadingData" style="background-color: #e9ecef;">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-12 col-md-12">
                    <ul class="topbar-social-links d-flex align-items-center py-3 px-0" *ngIf="isBig">
                        <a class="navbar-brand d-flex align-items-center">
                            <span class="placeholder" style="width: 80px; height: 80px; border-radius: 50%;"></span>
                            <span class="placeholder ms-3" style="width: 300px; height: 40px;"></span>
                        </a>
                    </ul>
                    <ul class="topbar-social-links py-3 px-0" *ngIf="isSmall">
                        <a class="navbar-brand d-flex align-items-center">
                            <span class="placeholder" style="width: 60px; height: 60px; border-radius: 50%;"></span>
                            <span class="placeholder ms-3" style="width: 200px; height: 30px;"></span>
                        </a>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- <img src="assets/img/school/navunderbg.jpg" style='width: 100%;'> -->
    <div class="karlson-nav">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light px-0">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent" *ngIf="isBig">
                    <ul class="navbar-nav" *ngIf="loadingData">
                        <li class="nav-item" *ngFor="let i of [1,2,3,4,5,6,7,8,9]">
                            <a class="nav-link placeholder-glow d-flex align-items-center" style="height: 100%;">
                                <span class="placeholder" style="width: 80px; height: 15px;"></span>
                            </a>
                        </li>
                    </ul>
                    <ul class="navbar-nav" *ngIf="!loadingData">
                        <li class="nav-item">
                            <a routerLink="/" routerLinkActive="active" class="nav-link">Home</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                About Proyash <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        style="margin-right: 0;">Overview<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/history" routerLinkActive="active"
                                                class="nav-link">History</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/organizational-structure" routerLinkActive="active"
                                                class="nav-link">Organizational Structure</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/es" routerLinkActive="active" class="nav-link">Education
                                                System</a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item dropdown">
                                    <a routerLink="/facilities/library" class="nav-link dropdown-toggle"
                                        href="javascript:void(0)" role="button" data-bs-toggle="dropdown"
                                        aria-expanded="false" style="margin-right: 0;"> Facilities<i
                                            class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/library" routerLinkActive="active"
                                                class="nav-link">Library</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/computer-lab" routerLinkActive="active"
                                                class="nav-link">Computer Lab</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/playground" routerLinkActive="active"
                                                class="nav-link">Playground</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/canteen" routerLinkActive="active"
                                                class="nav-link">Canteen</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/transport" routerLinkActive="active"
                                                class="nav-link">Transport</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/multipurposeShed" routerLinkActive="active"
                                                class="nav-link">Multipurpose
                                                Shed</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/inDoorGames" routerLinkActive="active"
                                                class="nav-link">Indoor Games</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/TailorShop" routerLinkActive="active"
                                                class="nav-link">Tailor Shop</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/gardenAndNursery" routerLinkActive="active"
                                                class="nav-link">Garden & Nursery</a>
                                        </li>
                                        <!-- <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                          <a routerLink="/facilities/gardenAndNursery" routerLinkActive="active"
                                              class="nav-link" style="color: white;">Garden & Nursery</a>
                                      </li> -->
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/vegetableAndFishMarket" routerLinkActive="active"
                                                class="nav-link">Vegetable &
                                                Fish Market</a>
                                        </li>
                                        <!-- <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                          <a routerLink="/facilities/barberShop" routerLinkActive="active"
                                              class="nav-link">Barber Shop</a>
                                      </li> -->
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/FishAquarium" routerLinkActive="active"
                                                class="nav-link">Fish Aquarium</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/modernClassroom" routerLinkActive="active"
                                                class="nav-link">Modern
                                                Classroom</a>
                                        </li>
                                        <!-- <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                          <a routerLink="/facilities/others" routerLinkActive="active"
                                              class="nav-link">Others</a>
                                      </li> -->
                                    </ul>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/ongoing-projects" routerLinkActive="active" class="nav-link">Ongoing
                                        Projects</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/future-plan" routerLinkActive="active" class="nav-link">Future
                                        Plan</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/administration" routerLinkActive="active"
                                        class="nav-link">Regulatory
                                        Body</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/messages" routerLinkActive="active" class="nav-link">Messages</a>
                                </li>
                                <!-- <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                  <a routerLink="/teachers" routerLinkActive="active" class="nav-link">Teachers</a>
                              </li>
                              <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                  <a routerLink="/staffs" routerLinkActive="active" class="nav-link">Staffs</a>
                              </li> -->
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        style="margin-right: 0;">Employee<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/teachers" routerLinkActive="active"
                                                class="nav-link">Teacher</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/therapist" routerLinkActive="active"
                                                class="nav-link">Therapist</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/teacher-assistant" routerLinkActive="active"
                                                class="nav-link">Teacher Assistant</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/education-assistant" routerLinkActive="active"
                                                class="nav-link">Education Assistant</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/staffs" routerLinkActive="active"
                                                class="nav-link">Administrative Staff</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/volunteer" routerLinkActive="active"
                                                class="nav-link">Volunteer</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Services Available <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        style="margin-right: 0;">Therapeutic Support Service<i
                                            class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/ot" routerLinkActive="active" class="nav-link">Occupational
                                                Therapy (OT)</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/pts" routerLinkActive="active" class="nav-link">Physio
                                                Therapy (PT)</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/slt" routerLinkActive="active" class="nav-link">Speech and
                                                Language Therapy (SLT) </a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/psychology" routerLinkActive="active"
                                                class="nav-link">Psychology</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/nutrition" routerLinkActive="active"
                                                class="nav-link">Nutrition</a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <!-- <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Outdoor
                                      Service</a> -->
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <!-- <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Proyash-Care</a> -->
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Education Program <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false" style="margin-right: 0;">Special
                                        Education Program<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/ecdp" routerLinkActive="active" class="nav-link">Early
                                                Childhood Development Program
                                                (ECDP)</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/vs" routerLinkActive="active" class="nav-link">Vocational
                                                Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/pps" routerLinkActive="active" class="nav-link">Pre-primary
                                                Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/autism" routerLinkActive="active" class="nav-link">Autism
                                                Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/hearing-section" routerLinkActive="active"
                                                class="nav-link">Hearing Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/id" routerLinkActive="active" class="nav-link">ID
                                                Section</a>
                                        </li>
                                    </ul>
                                </li>

                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Inclusive
                                      Education Program</a>
                              </li> -->
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/inclusion" routerLinkActive="active" class="nav-link">Inclusion</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Achievements <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Education</a>
                              </li> -->
                                <li class="nav-item">
                                    <a routerLink="/sports" routerLinkActive="active" class="nav-link">Sports</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/cultural" routerLinkActive="active" class="nav-link">Cultural</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/it" routerLinkActive="active" class="nav-link">IT</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/arts" routerLinkActive="active" class="nav-link">Arts</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/mee" routerLinkActive="active" class="nav-link">Mainstream
                                        Education & Employment</a>
                                </li>
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">International</a>
                              </li>
                              <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active" class="nav-link">Awards
                                      &
                                      Recognition</a>
                              </li>
                              <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Summary</a>
                              </li> -->
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Information <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        style="margin-right: 0;">Schools<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/ap" routerLinkActive="active" class="nav-link">Admission
                                                Procedure</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/volunteer-service" routerLinkActive="active"
                                        class="nav-link">Volunteer
                                        Service</a>
                                </li>

                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Resources <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a routerLink="/photo-gallery" routerLinkActive="active" class="nav-link">Photos</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/video-gallery" routerLinkActive="active" class="nav-link">Videos</a>
                                </li>
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Prospectus</a>
                              </li> -->
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Forms</a>
                              </li> -->
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/notice" routerLinkActive="active" class="nav-link">Notice
                                Board</a>
                        </li>
                        <!-- <li class="nav-item">
                          <a routerLink="/e-library" routerLinkActive="active" class="nav-link">E-Library</a>
                      </li> -->
                        <li class="nav-item">
                            <a routerLink="/contact" routerLinkActive="active" class="nav-link">Contact Us</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" style="margin-right: 0;">Login<i
                                    class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu" style='left: -100% !important; width: 180px !important;'>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a href='https://portal.cloudcampus24.com/UserAuth/Login?ReturnUrl=%2F'
                                        target='_blank' rel='noopener' class="nav-link">Admin Portal</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a href='https://portal.cloudcampus24.com/UserAuth/Login?ReturnUrl=%2F'
                                        target='_blank' rel='noopener' class="nav-link">Teacher Portal</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a href='https://portal.cloudcampus24.com/UserAuth/Login?ReturnUrl=%2F'
                                        target='_blank' rel='noopener' class="nav-link">Student Portal</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="collapse navbar-collapse mean-menu-new" id="navbarSupportedContent" *ngIf="isSmall">
                    <ul class="navbar-nav" *ngIf="loadingData">
                        <li class="nav-item" *ngFor="let i of [1,2,3,4,5,6,7,8,9]">
                            <a class="nav-link placeholder-glow d-flex align-items-center" style="height: 100%;">
                                <span class="placeholder" style="width: 100px; height: 15px;"></span>
                            </a>
                        </li>
                    </ul>
                    <ul class="navbar-nav" *ngIf="!loadingData">
                        <li class="nav-item">
                            <a routerLink="/" routerLinkActive="active" class="nav-link">Home</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                About Proyash <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        style="margin-right: 0;">Overview<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/history" routerLinkActive="active"
                                                class="nav-link">History</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/organizational-structure" routerLinkActive="active"
                                                class="nav-link">Organizational Structure</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/es" routerLinkActive="active" class="nav-link">Education
                                                System</a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item dropdown">
                                    <a routerLink="/facilities/library" class="nav-link dropdown-toggle"
                                        href="javascript:void(0)" role="button" data-bs-toggle="dropdown"
                                        aria-expanded="false" style="margin-right: 0;"> Facilities<i
                                            class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/library" routerLinkActive="active"
                                                class="nav-link">Library</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/computer-lab" routerLinkActive="active"
                                                class="nav-link">Computer Lab</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/playground" routerLinkActive="active"
                                                class="nav-link">Playground</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/canteen" routerLinkActive="active"
                                                class="nav-link">Canteen</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/transport" routerLinkActive="active"
                                                class="nav-link">Transport</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/multipurposeShed" routerLinkActive="active"
                                                class="nav-link">Multipurpose Shed</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/inDoorGames" routerLinkActive="active"
                                                class="nav-link">Indoor Games</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="facilities/TailorShop" routerLinkActive="active"
                                                class="nav-link">Tailor Shop</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/gardenAndNursery" routerLinkActive="active"
                                                class="nav-link">Garden & Nursery</a>
                                        </li>

                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/vegetableAndFishMarket" routerLinkActive="active"
                                                class="nav-link">Vegetable & Fish Market</a>
                                        </li>
                                        <!-- <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                          <a routerLink="/facilities/barberShop" routerLinkActive="active"
                                              class="nav-link">Barber Shop</a>
                                      </li> -->
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/FishAquarium" routerLinkActive="active"
                                                class="nav-link">Fish Aquarium</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/facilities/modernClassroom" routerLinkActive="active"
                                                class="nav-link">Modern Classroom</a>
                                        </li>
                                        <!-- <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                          <a routerLink="/facilities/others" routerLinkActive="active"
                                              class="nav-link">Others</a>
                                      </li> -->
                                    </ul>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/ongoing-projects" routerLinkActive="active" class="nav-link">Ongoing
                                        Projects</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/future-plan" routerLinkActive="active" class="nav-link">Future
                                        Plan</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/administration" routerLinkActive="active"
                                        class="nav-link">Regulatory
                                        Body</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/messages" routerLinkActive="active" class="nav-link">Messages</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/teachers" routerLinkActive="active" class="nav-link">Teachers</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a routerLink="/staffs" routerLinkActive="active" class="nav-link">Staffs</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Services Available <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <!-- <a routerLink="/underConstruction" routerLinkActive="active"
                                      [routerLinkActiveOptions]="{exact: true}" class="nav-link">Specialized
                                      Intervention Clinic</a> -->
                                </li>
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false" style="margin-right: 0;"><i
                                            class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/ot" routerLinkActive="active" class="nav-link">Occupational
                                                Therapy (OT)</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/pts" routerLinkActive="active" class="nav-link">Physio
                                                Therapy (PT)</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/slt" routerLinkActive="active" class="nav-link">Speech and
                                                Language Therapy
                                                (SLT) </a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/psychology" routerLinkActive="active"
                                                class="nav-link">Psychology</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/nutrition" routerLinkActive="active"
                                                class="nav-link">Nutrition</a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <!-- <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Outdoor
                                      Service</a> -->
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <!-- <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Proyash-Care</a> -->
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Education Program <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false" style="margin-right: 0;">Special
                                        Education Program<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/ecdp" routerLinkActive="active" class="nav-link">Early
                                                Childhood Development Program
                                                (ECDP)</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/vs" routerLinkActive="active" class="nav-link">Vocational
                                                Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/pps" routerLinkActive="active" class="nav-link">Pre-primary
                                                Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/autism" routerLinkActive="active" class="nav-link">Autism
                                                Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/hearing-section" routerLinkActive="active"
                                                class="nav-link">Hearing Section</a>
                                        </li>
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/id" routerLinkActive="active" class="nav-link">ID
                                                Section</a>
                                        </li>
                                    </ul>
                                </li>
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Inclusive
                                      Education Program</a>
                              </li> -->
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/inclusion" routerLinkActive="active" class="nav-link">Inclusion</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Achievements <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Education</a>
                              </li> -->
                                <li class="nav-item">
                                    <a routerLink="/sports" routerLinkActive="active" class="nav-link">Sports</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/cultural" routerLinkActive="active" class="nav-link">Cultural</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/it" routerLinkActive="active" class="nav-link">IT</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/arts" routerLinkActive="active" class="nav-link">Arts</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/mee" routerLinkActive="active" class="nav-link">Mainstream
                                        Education & Employment</a>
                                </li>
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">International</a>
                              </li>
                              <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active" class="nav-link">Awards
                                      &
                                      Recognition</a>
                              </li>
                              <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Summary</a>
                              </li> -->
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Information <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false"
                                        style="margin-right: 0;">Schools<i class="fas fa-chevron-down"></i>
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a routerLink="/ap" routerLinkActive="active" class="nav-link">Admission
                                                Procedure</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/volunteer-service" routerLinkActive="active"
                                        class="nav-link">Volunteer
                                        Service</a>
                                </li>

                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Resources <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a routerLink="/photo-gallery" routerLinkActive="active" class="nav-link">Photos</a>
                                </li>
                                <li class="nav-item">
                                    <a routerLink="/video-gallery" routerLinkActive="active" class="nav-link">Videos</a>
                                </li>
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Prospectus</a>
                              </li> -->
                                <!-- <li class="nav-item">
                                  <a routerLink="/underConstruction" routerLinkActive="active"
                                      class="nav-link">Forms</a>
                              </li> -->
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/notice" routerLinkActive="active" class="nav-link">Notice
                                Board</a>
                        </li>
                        <!-- <li class="nav-item">
                          <a routerLink="/e-library" routerLinkActive="active" class="nav-link">E-Library</a>
                      </li> -->
                        <li class="nav-item">
                            <a routerLink="/contact" routerLinkActive="active" class="nav-link">Contact Us</a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" style="margin-right: 0;">Login<i
                                    class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a href='https://portal.cloudcampus24.com/UserAuth/Login?ReturnUrl=%2F '
                                        target='_blank' rel='noopener' class="nav-link">Admin Portal</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a href='https://portal.cloudcampus24.com/UserAuth/Login?ReturnUrl=%2F'
                                        target='_blank' rel='noopener' class="nav-link">Teacher Portal</a>
                                </li>
                                <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a href='https://portal.cloudcampus24.com/UserAuth/Login?ReturnUrl=%2F'
                                        target='_blank' rel='noopener' class="nav-link">Student Portal</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>


</div>